import { DestinationSearchBlockOffer } from 'src/modules/cms';

export const filterDestinations = (
  destinations: DestinationSearchBlockOffer[],
  showRoundTripPrice: boolean,
  maxPrice: number | undefined,
  showDirectFlightsOnly: boolean
): DestinationSearchBlockOffer[] => {
  return (destinations ?? []).filter((destination) => {
    if (showDirectFlightsOnly && !destination.directFlight) {
      return false;
    }

    if (maxPrice !== undefined && maxPrice > 0) {
      return (
        parseInt(
          showRoundTripPrice
            ? destination.returnPrice?.price.amount
            : destination.isShortHaul
              ? destination.onewayPrice?.price.amount
              : destination.returnPrice?.price.amount,
          10
        ) <= maxPrice
      );
    }
    return true;
  });
};
